export enum GameLimitTypes {
  NO_LIMIT = 'no_limit',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  ONCE = 'once'
}
